/**
* @prop --component-sticky-toolbar-item-color-bg: Background color of sticky toolbar item
* @prop --component-sticky-toolbar-item-color-bg-active: Background color of sticky toolbar item in active state
* @prop --component-sticky-toolbar-item-color-icon: Color of sticky toolbar item icon
* @prop --component-sticky-toolbar-item-color-icon-active: Color of sticky toolbar item icon in active state
* @prop --component-sticky-toolbar-item-color-content-bg: Background color of sticky toolbar item content
*/

@import '../../../../global/utility/skinning/invert-colors';
@import '../../../../global/utility/sticky-toolbar/sticky-toolbar-item-styles';

@mixin toolbar-channel_contactbox {
  display: inline-block;
  margin-top: 0;

  .channel-contactbox {
    margin-top: 0;
  }
}

.notify {
  .channel-contactbox {
    *:not(.button) {
      display: none;
    }
  }
}

:host {
  @include sticky-toolbar-item-styles;

  ::slotted(*) {
    margin-top: 30px;
  }

  // This overrides the color of the icon only when the item is open
  sd-button {
    &.open {
      sd-icon {
        color: $sd-backgroundColor-accent-500;
      }
    }
  }

  .sr-only {
    @include sr-only;
  }
}
